import {getParameterByName, isConnexDoor} from "../../shared/utils";
import {LoginAPI} from "../../apis/LoginAPI";

export default [
    {
         path: '/',
        redirect: { name: 'users_login' }
    },
    {
    path: '/login',
    name: 'users_login',
    component: () => import('./containers/Login'),
    children: []
}, {
    path: '/signup/:priceId?',
    name: 'users_signup',
    component: () => {
        if(isConnexDoor()) {
            return import('./containers/SignupConnex')
        }
        return import('./containers/Signup')
    },
    children: []
},{
    path: '/investor-signup',
    name: 'users_signup_investor',
    component: () => {
        return import('./containers/Signup')
    },
    children: []
},/*{
    path: '/partners/signup/:investorToken',
    name: 'users_signup',
    component: () => import('./containers/SignupInvestor'),
    children: []
}, */{
    path: '/forget-password',
    name: 'users_forget_password',
    component: () => import('./containers/ForgetPassword'),
    children: []
}, {
    path: '/set-password',
    name: 'users_set_password',
    component: () => import('./containers/SetPassword'),
    children: []
}, {
    path: '/google-login',
    name: 'users_google_login',
    redirect: async function () {
        let resp = await LoginAPI.googleLogin({
            code: getParameterByName('code')
        });
        if (resp.success === true) {
            if (resp.is_new) {
                window.location.href = '/signup';
            } else {
                window.location.href = '/dashboard';
            }
        }
    }
}, {
    path: '/fb-login',
    name: 'users_fb_login',
    redirect: async function () {
        let resp = await LoginAPI.facebookLogin({
            code: getParameterByName('code')
        });

        if (resp.success === true) {
            window.location.href = '/';
        }
    }
}, {
    name: 'users_verify_email',
    path: '/verify-email',
    component: () => import('./containers/VerfyEmail'),
}, {
    name: 'onboarding',
    path: '/onboarding',
    component: () => import('./containers/OnBoarding'),
}, {
    path: '/user-type',
    name: 'user-type',
    component: () => import('../login/containers/UserType'),
},];
